import { render, staticRenderFns } from "./TeamsportPlayerPoolRecruitmentCard.vue?vue&type=template&id=f8a8c374"
import script from "./TeamsportPlayerPoolRecruitmentCard.vue?vue&type=script&lang=js"
export * from "./TeamsportPlayerPoolRecruitmentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports